import React from 'react'

import { FAQ } from '@/components/shipplay/content/FAQ'
import { HowItWorksSteps } from '@/components/shipplay/content/HowItWorksSteps'
import { ReviewFeed } from '@/components/shipplay/content/ReviewFeed'
import { Hero } from '@/components/shipplay/Hero'
import { IntroBlock } from '@/components/shipplay/ui_patterns/IntroBlock'

import { cn } from '../../components/shipplay/ui/cn'

import { shipplayContent } from './shipplay.page.content'

/**
 * Ship&Play "How It Works" page — hero + step-by-step SplitBlocks +
 * customer resources + FAQ, ported from playground-shipplay's
 * HowItWorksPage. Outer chrome (SiteUserBar / SiteNav / ConciergeTeam /
 * SiteFooter) comes from ClientLayout, matching ShipplayHomePage.
 *
 * Copy lives in `shipplay.page.content.tsx`'s named `shipplayContent`
 * export so it can be swapped without touching JSX.
 */
const ShipplayHowItWorksPage: React.FC = () => {
  const { hero, intro, howItWorksSteps } = shipplayContent

  return (
    <>
      <Hero imgUrl={hero.imgUrl}>
        <div
          className={cn(
            'snplay-text-bg-blur-dark snplay:col-span-12',
            'snplay:sm:col-span-8 snplay:lg:col-span-6',
          )}
        >
          <h1
            className={cn(
              'snplay:text-4xl snplay:font-bold snplay:sm:text-5xl',
              'snplay:md:text-6xl snplay:2xl:text-7xl',
            )}
          >
            {hero.title.prefix}
            <span className="snplay:text-primary">{hero.title.emphasis}</span>
            {hero.title.suffix}
          </h1>
          {hero.subheading && (
            <p className="snplay:mt-6 snplay:text-2xl snplay:font-semibold">{hero.subheading}</p>
          )}
          {hero.description && (
            <p className="snplay:mt-4 snplay:text-xl snplay:leading-normal">{hero.description}</p>
          )}
        </div>
      </Hero>
      <IntroBlock title={intro.title}>{intro.body}</IntroBlock>
      <HowItWorksSteps content={howItWorksSteps} />
      <FAQ group="default" />
      <ReviewFeed />
    </>
  )
}

export default ShipplayHowItWorksPage
